import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { PowerPlayerBoltInlineIcon } from '../../../assets/powerPlayerBoltInlineIcon';
import { BOLD_FONT_FAMILY } from '../../../constants/constants';
import { TRANSITION_ANIMATION_BACKGROUND_COLOR } from '../../../styles/colors';
const CONTAINER_CSS = css `
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;
const MESSAGE_CONTAINER_CSS = css `
  background-color: ${TRANSITION_ANIMATION_BACKGROUND_COLOR};
  border-radius: 20px;
  padding: 20px;
`;
const MESSAGE_CSS = css `
  font-family: ${BOLD_FONT_FAMILY};
  color: white;
  font-size: 20px;
  filter: drop-shadow(3px 3px 0 rgba(0, 0, 0, 0.5));
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;
export const TransitionMessageDisplay = ({ transitionAnimationMessage }) => {
    const { message, messageType } = transitionAnimationMessage;
    return (_jsx("div", { css: CONTAINER_CSS, children: _jsx("div", { css: MESSAGE_CONTAINER_CSS, children: _jsxs("div", { css: MESSAGE_CSS, "aria-label": 'loading message', children: [messageType === 'power-player-suggestion' && (_jsx(PowerPlayerBoltInlineIcon, { powerPlayerBoltColor: 'yellow', size: 24 })), _jsx("span", { children: message })] }) }) }));
};
